<template>
  <div class="video-box">
    <div id="app" style="height:calc(100% - 50px);">
      <div id="videoContent">
        <div class="control_content">
          <div class="video_search">
            <el-input placeholder="请输入关键字查询" v-model="input" clearable>
              <el-button slot="append" icon="el-icon-search" type="primary"></el-button>
            </el-input>
          </div>
          <div class="video_list" :style="!videoControlShow?'height:calc(100% - 360px)':''">
            <el-checkbox-group v-model="checkList" @change="chenkChan">
              <el-checkbox v-for="(item,index) in  videoList" :key="index + item.deviceSerial" v-show="item.name.indexOf(input.replace(' ','')) != -1" :index="index" :label="item">{{item.name}}
                <div class="offLine" v-if="item.status==0">离线</div>
              </el-checkbox>
          
            </el-checkbox-group>
          </div>
        </div>
        <div id="shrinkContent">
          <img id="shrink" :src='require("../../public/video_plug-in/img/shrink.png")' alt="" />
        </div>
      </div>
      <!-- 单个 -->
      <div v-show="singleShow" style=" width: 100%; height: 100%;">
        <div id="videoPlay" style="z-index:-1;width: calc(100% - 340px);"></div>
      </div>
      <!-- 4个 -->
      <div id="videoPlayTui4" class="videostyle" v-if="doubleShow">
        <div class="video2x2" v-for="(item,index) in checkList" :key="item.name" @click="videoClick(index)" v-bind:style="index == checkeditem ? boxstylebor:''">
          <video :id="'myPlayer'+item.deviceSerial+item.channelNo" playsInline webkit-playsinline autoplay>
            <source :src="item.PUrl" type="" />
          </video>
          <img src="../assets/img/videolog.gif" alt="" :ref="'login'+ item.deviceSerial + item.channelNo" v-if="!!item.channelNo">
        </div>

      </div>
      <!-- 9个 -->
      <div id="videoPlayTui9" class="videostyle" v-if="tripleShow">
        <div class="video3x3" v-for="(item,index) in checkList" :key="item.name" @click="videoClick(index)" v-bind:style="index == checkeditem ? boxstylebor:''">
          <video :id="'myPlayer'+item.deviceSerial+item.channelNo" playsInline webkit-playsinline autoplay>
            <source :src="item.PUrl" type="" />
          </video>
          <img src="../assets/img/videolog.gif" alt="" :ref="'login'+item.deviceSerial + item.channelNo" v-if="!!item.channelNo">
        </div>
      </div>
    </div>
    <div class="video_control_bottom">
      <div class="video_control_left">
        <div class="video_control_box" :style="videoControlShow?'height:40px':''">
          <div class="video_control_set" style="visibility:hidden;"><i class="el-icon-s-tools" style="margin-right:5px;"></i>云台控制</div>
          <!--                    <div class="video_control_unfold" v-show="videoControlShow" @click="videoControlShow = !videoControlShow"><i class="el-icon-arrow-up"style="margin-right:10px;"></i></div>-->
          <!--                    <div class="video_control_unfold" v-show="!videoControlShow"  @click="videoControlShow = !videoControlShow"><i class="el-icon-arrow-down"style="margin-right:10px;"></i></div>-->
          <!-- <div class="video_control">
            <!-- 方向控制 -->
            <!-- <div class="direction_control">
              <div class="control-wrapper">
                <div class="control-btn control-top" onmousedown="window.directionStart(0)" onmouseup="window.directionStop()">
                  <i class="fa el-icon-caret-top"></i>
                  <div class="control-inner-btn control-inner"></div>
                </div>
                <div class="control-btn control-left" onmousedown="window.directionStart(2)" onmouseup="window.directionStop()">
                  <i class="fa el-icon-caret-left"></i>
                  <div class="control-inner-btn control-inner"></div>
                </div>
                <div class="control-btn control-bottom" onmousedown="window.directionStart(1)" onmouseup="window.directionStop()">
                  <i class="fa el-icon-caret-bottom"></i>
                  <div class="control-inner-btn control-inner"></div>
                </div>
                <div class="control-btn control-right" onmousedown="window.directionStart(3)" onmouseup="window.directionStop()">
                  <i class="fa el-icon-caret-right"></i>
                  <div class="control-inner-btn control-inner"></div>
                </div>
                <div class="control-round" id="stopControl">
                  <div class="control-round-inner">
                    <i class="fa el-icon-video-play"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="focusing">
              <div class="focusingIcon" style="float:left;" onmousedown="window.directionStart(10)" onmouseup="window.directionStop()"><i class="el-icon-full-screen"></i>-</div>
              焦距
              <div class="focusingIcon" style="float:right;" onmousedown="window.directionStart(11)" onmouseup="window.directionStop()"><i class="el-icon-full-screen"></i>+</div>
            </div>
          </div> --> 
        </div>
      </div>
      <div class="video_control_right">
        <div style="float:left;">
          <i class="el-icon-zoom-in" title="放大" onmousedown="window.directionStart(8)" onmouseup="window.directionStop()"></i>
          <i class="el-icon-zoom-out" title="缩小" onmousedown="window.directionStart(9)" onmouseup="window.directionStop()"></i>
          <i class="el-icon-monitor" :style="singleShow?'color:#409EFF;':''" title="1x1" id="multiwindow" @click="singlefn"></i>
          <!-- <i class="el-icon-menu" :style="doubleShow?'color:#409EFF;':''" title="2X2" id="multiwindow" @click="doubleFn"></i>
          <i class="el-icon-s-grid" :style="tripleShow?'color:#409EFF;':''" title="3X3" id="multiwindow1" @click="tripleFn"></i> -->
        </div>
        <div style="float:right;">
          <!-- <i class="el-icon-video-play" title="视频回放" id="playBack"></i>
          <i class="el-icon-video-camera-solid" title="录制" id="recordVideo"></i> -->
          <i class="el-icon-picture" title="截图" id="printscreen"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse, CollapseItem, Input, Button, Checkbox, CheckboxGroup, Popover, Radio, Loading } from "element-ui";
import EZUIKit from '../../public/video_plug-in/lib/ezuikit-2.6'
import "../../public/video_plug-in/js/request";
import axios from "axios"
import { request, requestYSY, requestCamera, requestArr1 } from "../network/request";
export default {
  name: "infoVideo",
  data: function () {
    return {
      loadingInstance: "",
      input: "",
      radio: "",
      videoList: [],
      checkList: [],
      videoFn: null,
      accessToken: "",
      expireTime: "",
      singleShow: true,
      doubleShow: false,//2x2
      tripleShow: false,//3x3
      videoControlShow: true,
      checkindex: null,
      boxstylebor: {
        border: '5px solid #ffcc00'
      },
      oldcheckList: [],//旧的选中列表
      playitem: [],//播放列表
      checkeditem: 0,
      jieliu: true,
    }
  },
  
  computed: {
    videoNum () {
      if (this.doubleShow && !this.tripleShow) return 4;
      if (this.tripleShow && !this.doubleShow) return 9;
      return 100;
    }
  },

  watch: {

    doubleShow: function (val) {
      if (val && this.tripleShow == true) {
        this.tripleShow = false;
      } else if (!val && !this.tripleShow) {
        this.checkList.length > 0 ? this.checkList = [this.checkList[0]] : "";
      }
    },
    // 3x3
    tripleShow: function (val) {
      if (val && this.doubleShow == true) {
        this.doubleShow = false;
      } else if (!val && !this.doubleShow) {
        this.checkList.length > 0 ? this.checkList = [this.checkList[0]] : "";
      }
    },
    checkList: function (newData, oldData) {
      if (this.singleShow) { return }

      this.$nextTick(() => {
        // 多个窗口使用hls推流方式
        if (this.jieliu) {
          //添加勾选
          if (newData.length > oldData.length) {
            this.jieliu = false
            this.checkList[this.checkeditem] = newData.pop()
            // setTimeout(() => { this.jieliu = true }, 200);
          }
          //取消勾选
          if (newData.length < oldData.length) {
            // 两数组不同的元素，就是勾选的元素
            function getArrDifference (arr1, arr2) {
              return arr1.concat(arr2).filter((v, i, arr) => {
                return arr.indexOf(v) === arr.lastIndexOf(v);
              });
            }
            this.jieliu = false
            // 获取勾选索引，并替换为空
            let Uncheckindex = oldData.indexOf(getArrDifference(oldData, newData)[0])
            oldData[Uncheckindex] = {}
            this.checkList = oldData
            // setTimeout(() => { this.jieliu = true }, 200);
          }
          this.hlsPlayfn()
          // setTimeout(() => {
          //   this.playitem.forEach( (item)=> {

          //   })

          // }, 5000);
        }
      })
    }
  },
  methods: {
    chenkChan () {
      this.jieliu = true
      if (!this.doubleShow && !this.tripleShow) {
        this.loadingInstance = Loading.service({ fullscreen: true });
        setTimeout(() => { this.loadingInstance.close() }, 1000);
        this.checkList = [this.checkList[this.checkList.length - 1]]
        // 记录当前勾选的状态
        localStorage.chcklist = JSON.stringify([this.checkList[this.checkList.length - 1]])
        this.$nextTick(() => this.videoFn.videoListPlay(this.checkList))
      }


    },
    // hls推流方式播放
    hlsPlayfn () {
      this.checkList.forEach((item, index) => {
        if (item.channelNo) {
          if (!!this.playitem[index] && this.playitem[index].opt.currentSource == item.PUrl) {

          } else {
            this.playitem[index] = new EZUIKit.EZUIPlayer('myPlayer' + item.deviceSerial + item.channelNo);
            // 日志绑定转圈动画
            this.playitem[index].logingref = 'login' + item.deviceSerial + item.channelNo
          }
          let that = this
          this.playitem[index].on('log', function (log) {
            if (log.indexOf('当音频/视频已开始或不再暂停时') != -1) {
              that.$refs[this.logingref][0].style.visibility = 'hidden';
            }
          });
        }
      })
    },
    // 点击的窗口
    videoClick (index) {
      this.checkeditem = index
    },
    // 2x2分屏幕
    doubleFn () {
      this.doubleShow = true;
      this.singleShow = false
      this.tripleShow = false
      if (this.checkList.length > 4) {
        // 结束索引4以后的视频
        this.playitem.slice(4).forEach(item => item.stop())
        this.checkList = this.checkList.splice(0, 4)
        return
      } else {
        // 切换为4框，不够就push进数组
        let indexleng = 4 - this.checkList.length
        for (let index = 0; index < indexleng; index++) {
          this.checkList.push({})
        }
        this.hlsPlayfn()
      }

    },
    // 3x3分屏幕
    tripleFn () {
      this.tripleShow = true
      this.singleShow = false
      this.doubleShow = false;
      // 切换为9框，不够就push进数组
      let indexleng = 9 - this.checkList.length
      for (let index = 0; index < indexleng; index++) {
        this.checkList.push({})
      }
      this.hlsPlayfn()
    },
    // 停止所有hls监控
    stopHls(){
       this.playitem.forEach(item => item.stop())
    },
    // 1x1
    singlefn () {
      this.singleShow = true
      this.tripleShow = false
      this.doubleShow = false;
      this.stopHls()
      this.getVideolist()
      this.loadingInstance = Loading.service({ fullscreen: true });
      setTimeout(() => { this.loadingInstance.close() }, 3000);
    },
    // 获取视频列表,存取列表
    getVideolist () {
      this.videoList = [];
      let videoRes = [];
     this.axios.get(this.$store.state.Url4+"staVideo/findStationVideoByPage", {
        params: {
          videoName: "",
          videoIp: "",
          videoPath: "",
          startPage: 1,
          limit: 1000
        }
      }).then(res => {
        videoRes = res.data.data;
        this.accessToken = res.data.data.length > 0 ? res.data.data[0].accessToken : ''
        this.videoFn.videoInitFn(this.accessToken, this.videoList)
        videoRes.forEach((item, index) => {
          this.videoList.push({
            deviceSerial: item.deviceNumber,
            channelNo: item.PCannel,
            name: item.videoName,
            accessToken: item.accessToken,
            PUrl: item.PUrl,
            status: item.status
          })
        })
        localStorage.videoList = JSON.stringify(this.videoList)
        localStorage.chcklist = JSON.stringify([this.videoList[0]])
        this.checkList = [this.videoList[0]]
        this.$nextTick(() => this.videoFn.videoListPlay([this.videoList[0]]))
      })
    }

  },
  activated () {
    let headDom = document.getElementsByTagName("head")[0];
    let scriptDom = headDom.getElementsByTagName("script");
    scriptDom.forEach(item => {
      item.src.indexOf("/arcgis_js_v317_api/arcgis_js_api/library/3.17/3.17/esri/nls/jsapi_zh-cn.js") != -1 ? window.location.reload() : "";
    })
  },
  created () {
      localStorage.removeItem("videoList");
      this.videoList = [];
      this.getVideolist()

  },
  mounted () {
    this.videoFn = require('../../public/video_plug-in/js/hls/main')
    // if (!JSON.parse(localStorage.videoList).length > 0 || !localStorage.videoList) {
      // this.getVideolist()
    // } else {//本地有视频列表
    //   this.videoList = JSON.parse(localStorage.videoList)
    //   this.accessToken = this.videoList.length > 0 ? this.videoList[0].accessToken : ''
    //   this.videoFn.videoInitFn(this.accessToken, this.videoList)
    //   //本地有选中列表
    //   if (localStorage.chcklist) {
    //     this.checkList = this.videoList.filter(item => item.name == JSON.parse(localStorage.chcklist)[0].name)
    //   }
      this.$nextTick(() => this.videoFn.videoListPlay(this.checkList))
    // }

  },
  components: {
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem,
    "el-input": Input,
    "el-button": Button,
    "el-checkbox": Checkbox,
    "el-checkbox-group": CheckboxGroup,
    "el-radio": Radio
  }
}
</script>

<style scoped>
@import "../../public/video_plug-in/css/video.css";
@import "../../public/video_plug-in/lib/layui/css/layui.css";
.video-box {
  height: 100%;
}
.video_list {
  position: relative;
  transition: height 1s;
}
.video_list > div {
  border-top: 1px solid #eee;
}
.el-checkbox {
  padding: 10px 20px;
  margin-right: 0;
  border-bottom: 1px solid #eee;
}
.video_search {
  padding: 10px;
}
.monitorIcon {
  margin-left: 20px;
}
.monitorIcon:before {
  margin-right: 10px;
}
.monitorItem {
  text-indent: 40px;
}
.monitorItem:hover {
  background-color: #b7ceda;
}
.video_control_bottom {
  height: 40px;
  width: 100%;
  background: #fff;
}
.video_control_left {
  width: 329px;
  float: left;
  height: 40px;
  border-right: 1px solid #ccc;
  position: relative;
  line-height: 40px;
}
.video_control_set {
  float: left;
  margin-left: 20px;
}
.video_control_unfold {
  float: right;
  cursor: pointer;
}
.video_control_right i {
  display: inline-block;
  padding: 13px;
  font-size: 18px;
  cursor: pointer;
}
.video_control_right i:hover {
  color: #0aa7ed;
}
.video_control_right i:active {
  color: #0b3560;
}
.focusingIcon {
  width: 30px;
  height: 30px;
  line-height: 30px;
  position: relative;
  text-align: center;
  font-size: 18px;
}
.focusingIcon:hover {
  color: #0aa7ed;
}
.focusing {
  width: 120px;
  margin: 0 auto;
  overflow: hidden;
  line-height: 30px;
  height: 30px;
  text-align: center;
  color: #333;
}
.focusingIcon i {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 30px;
}
.video_list label {
  width: 100%;
}
.control-wrapper {
  position: relative;
  width: 50vw;
  height: 50vw;
  max-width: 200px;
  max-height: 200px;
  margin-top: 30px;
  border-radius: 100%;
}

.offLine {
  border-radius: 6px;
  line-height: 25px;
  text-align: center;
  position: absolute;
  right: 65px;
  top: 8px;
  width: 45px;
  height: 25px;
  color: white;
  background-color: #8e9491;
}
.control-btn {
  background: #219ee8;
  display: flex;
  justify-content: center;
  position: absolute;
  width: 44%;
  height: 44%;
  border-radius: 15px;
  border: 1px solid #78aee4;
  box-sizing: border-box;
  transition: all 0.3s linear;
}
.control-btn:hover {
  background: #0d64a9;
}
.control-btn:active {
  background: #0b3560;
}
.control-btn i {
  font-size: 20px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.control-round-inner:hover {
  background: #0d64a9;
}
.control-round-inner:active {
  background: #0b3560;
}
.el-icon-full-screen:hover {
  color: #0d64a9;
}
.el-icon-full-screen:active {
  color: #0b3560;
}
.control-round {
  position: absolute;
  top: 21%;
  left: 21%;
  width: 58%;
  height: 58%;
  background: #e8eff5;
  border-radius: 100%;
}

.control-round-inner {
  background: #219ee8;
  position: absolute;
  left: 15%;
  top: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  height: 70%;
  font-size: 40px;
  color: #fff;
  border: 1px solid #78aee4;
  border-radius: 100%;
  transition: all 0.3s linear;
}

.control-inner-btn {
  position: absolute;
  width: 60%;
  height: 60%;
  background: #e8eff5;
}

.control-top {
  top: -3%;
  left: 27%;
  transform: rotate(-45deg);
  border-radius: 5px 100% 5px 0;
}

.control-top .control-inner {
  left: -1px;
  bottom: 0;
  border-top: 1px solid #78aee4;
  border-right: 1px solid #78aee4;
  border-radius: 0 100% 0 0;
}

.control-top .fa {
  transform: rotate(45deg) translateY(-7px);
}

.control-left {
  top: 27%;
  left: -3%;
  transform: rotate(45deg);
  border-radius: 5px 0 5px 100%;
}

.control-left .control-inner {
  right: -1px;
  top: -1px;
  border-bottom: 1px solid #78aee4;
  border-left: 1px solid #78aee4;
  border-radius: 0 0 0 100%;
}

.control-left .fa {
  transform: rotate(-45deg) translateX(-7px);
}

.control-right {
  top: 27%;
  right: -1%;
  transform: rotate(45deg);
  border-radius: 5px 100% 5px 0;
}

.control-right .control-inner {
  left: -1px;
  bottom: -1px;
  border-top: 1px solid #78aee4;
  border-right: 1px solid #78aee4;
  border-radius: 0 100% 0 0;
}

.control-right .fa {
  transform: rotate(-45deg) translateX(7px);
}

.control-bottom {
  left: 27%;
  bottom: -1%;
  transform: rotate(45deg);
  border-radius: 0 5px 100% 5px;
}

.control-bottom .control-inner {
  top: -1px;
  left: -1px;
  border-bottom: 1px solid #78aee4;
  border-right: 1px solid #78aee4;
  border-radius: 0 0 100% 0;
}

.control-bottom .fa {
  transform: rotate(-45deg) translateY(7px);
}
.video_control_box {
  position: absolute;
  height: 340px;
  bottom: 0px;
  left: 0px;
  width: 100%;
  transition: height 1s;
  background: #fff;
}
.parent-wnd > div {
  position: relative;
}
.left,
.top,
.right,
.bottom {
  width: 40px;
  height: 40px;
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  text-align: center;
  line-height: 40px;
  z-index: 1000;
}
.left {
  left: 0;
  top: 50%;
  margin-top: -20px;
}
.right {
  right: 0px;
  top: 50%;
  margin-top: -20px;
}
.top {
  top: 0;
  left: 50%;
  margin-left: -20px;
}
.bottom {
  bottom: 0;
  left: 50%;
  margin-left: -20px;
}
.videostyle {
  height: 100%;
  z-index: -1;
  width: calc(100% - 340px);
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.videostyle > .video2x2 {
  box-sizing: border-box;
  border: 1px solid #ccc;
  width: 50%;
  height: 50%;
}
.video2x2 > img,
.video3x3 > img {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -13px;
  margin-right: -13px;
  width: 26px;
}
.video2x2,
.video3x3 {
  position: relative;
}
.video2x2 > video,
.video3x3 > video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.videostyle > .video3x3 {
  box-sizing: border-box;
  border: 1px solid #ccc;
  width: 33.3333%;
  height: 33.3333%;
}
#videoPlayTui9,
#videoPlayTui4,
#videoPlay {
  background-color: #4c4b4b;
}
</style>


// WEBPACK FOOTER //
// src/components/video.vue